var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2162 8.52702H9.0901V9.65315H10.2162M10.2162 6.27477H9.0901V7.40089H10.2162M11.3423 10.7793H6.83784V9.65315H7.96397V8.52702H6.83784V7.40089H7.96397V6.27477H6.83784V5.14864H11.3423M5.71172 4.02252H4.58559V2.89639H5.71172M5.71172 6.27477H4.58559V5.14864H5.71172M5.71172 8.52702H4.58559V7.40089H5.71172M5.71172 10.7793H4.58559V9.65315H5.71172M3.45947 4.02252H2.33334V2.89639H3.45947M3.45947 6.27477H2.33334V5.14864H3.45947M3.45947 8.52702H2.33334V7.40089H3.45947M3.45947 10.7793H2.33334V9.65315H3.45947M6.83784 4.02252V1.77026H1.20721V11.9054H12.4685V4.02252H6.83784Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/companyIcon.05e7473075e9b6d53b62747968777eb2.svg";
export { ForwardRef as ReactComponent };